// src/components/Modal.jsx
import React from 'react';

const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Oscurecer un poco menos el fondo
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    backdropFilter: 'blur(2px)' // Efecto borroso moderno
  },
  content: {
    // CAMBIO: Fondo gris claro como en la imagen
    backgroundColor: '#F2F2F7', 
    padding: '20px 20px 30px 20px',
    // CAMBIO: Bordes muy redondeados (estilo iOS)
    borderRadius: '20px', 
    maxWidth: '450px', // Ancho más angosto como una tarjeta móvil
    width: '95%',
    position: 'relative',
    boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
    maxHeight: '90vh',
    overflowY: 'auto',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
  },
  closeButton: {
    position: 'absolute',
    top: '15px',
    right: '15px',
    width: '30px',
    height: '30px',
    background: '#E5E5EA', // Círculo gris
    borderRadius: '50%',
    border: 'none',
    fontSize: '1.2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: '#8E8E93',
    zIndex: 10
  }
};

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div style={modalStyles.overlay} onClick={onClose}>
      <div style={modalStyles.content} onClick={(e) => e.stopPropagation()}>
        <button style={modalStyles.closeButton} onClick={onClose}>&times;</button>
        {children}
      </div>
    </div>
  );
};

export default Modal;